/* @flow */

import Cookies from 'js-cookie';
import { parse } from 'url';

import { getUserId, getUserFullName } from '@e180/domain/lib/user/util';
import { assertObject } from '@e180/util/lib/assert';
import * as Sentry from '@sentry/browser';

import { tokenQueryParam } from 'src/shared/app/base/route/setting/querySettings';

import type { User } from '@e180/domain/lib/user/type';

export function isTokenInCookie(): boolean {
  return !!Cookies.get('token');
}

export function saveTokenInCookie(
  token: string,
  secure?: boolean = true,
): void {
  Cookies.set('token', token, { expires: 365, path: '/', secure });
}

export function getTokenInCookie(): string {
  return Cookies.get('token');
}

export function removeTokenFromCookie(): void {
  Cookies.remove('token', { path: '/' });
}

export function registerSentryUserFromBrowser(user: User): void {
  assertObject(user, 'user');

  Sentry.configureScope((scope) => {
    scope.setUser({ id: getUserId(user), username: getUserFullName(user) });
  });
}

export function unregisterSentryUserFromBrowser(): void {
  Sentry.configureScope((scope) => {
    scope.setUser();
  });
}

export function injectTokenInCookie(): void {
  // @TODO - TEMP-AUTH
  const queryToken = getQueryToken(window.location.href);
  if (queryToken) {
    // @TODO - TEMP-AUTH Use env provider
    saveTokenInCookie(queryToken, !process.env.DEV_MODE);
  }
}

export function getQueryToken(url: string): void {
  const { query } = parse(url, true);
  const queryToken = (query: Object)[tokenQueryParam];
  return queryToken;
}
